import { render, staticRenderFns } from "./DeskSelectBox.vue?vue&type=template&id=3b213b1f&"
import script from "./DeskSelectBox.vue?vue&type=script&lang=js&"
export * from "./DeskSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports